import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=0aad4cfb&"
import script from "./CustomerPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports